"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgramContent = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./ProgramContent.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ProgramContent = _ref => {
  let {
    rate,
    description,
    creditLimitMillions,
    termYears
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles['parameters']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['header']
  }, ['Ставка', 'Сумма кредита', 'Срок'].map(header => /*#__PURE__*/React.createElement(_uiKit.ArticleParagraph3, {
    color: "gray60_100",
    key: header
  }, header))), /*#__PURE__*/React.createElement("div", {
    className: styles['row']
  }, /*#__PURE__*/React.createElement(_uiKit.UIText1, null, rate, "%"), /*#__PURE__*/React.createElement(_uiKit.UIText1, null, "\u0434\u043E ", creditLimitMillions, " \u043C\u043B\u043D \u20BD"), /*#__PURE__*/React.createElement(_uiKit.UIText1, null, "\u0434\u043E ", termYears, " \u043B\u0435\u0442"))), /*#__PURE__*/React.createElement("div", {
    className: styles['description']
  }, description));
};
exports.ProgramContent = ProgramContent;